webpackJsonp([803697644630],{

/***/ 1149:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(752);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(753);
	
	var _4 = _interopRequireDefault(_3);
	
	var _5 = __webpack_require__(754);
	
	var _6 = _interopRequireDefault(_5);
	
	var _reactResponsiveEmbed = __webpack_require__(26);
	
	var _reactResponsiveEmbed2 = _interopRequireDefault(_reactResponsiveEmbed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function Index(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "c-content-box" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Displacement-Based Design"
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { textAlign: 'justify', lineHeight: '2em' } },
	      _react2.default.createElement("img", { src: _2.default, style: { width: '100%', height: '100%' } }),
	      "Ho maturato esperienza nel Displacement-Based Design delle struttura (specialmente in CA). Come spiego in seguito, questo \xE8 un metodo di progetto pi\xF9 razionale rispetto al tradizionale progetto basato sulle forze (Force-Based Design). Questo metodo permette di avere una risposta strutturale pi\xF9 controllabile ed efficiente e, spesso, un progetto meno costoso. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Force-Based Design"
	      ),
	      "Il metodo di progetto sismico tradizionale e pi\xF9 comunemente adottato \xE8 il Force-Based Design (FBD), poich\xE8 le forze sismiche sono alla base del metodo. In sostanza gli elementi strutturali sono predimensionati basandosi sui carichi gravitazionali (ad esempio). Sulla base della rigidezza (periodo) elastica della struttura, le forze sismiche sono calcolate attraverso un spettro di risposta elastico. Quindi quest'ultimo \xE8 ridotto utilizzand ad esempio la regola dell'ugual spostamento (o dell'ugual energia). Ad esempio, la prima regola ipotizza che la domanda di spostamento di un sistema ad un grado di libert\xE0 non-lineare sia uguale alla domanda di un oscillatore elastico con la stessa rigidezza elastica. Sulla base di questa regola si riduce la domanda sismica di forza e si progetta la struttura. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("img", { src: _4.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Displacement-Based Design"
	      ),
	      "Tuttavia per strutture in CA o in muratura la rigidezza elastica dipende dalla resistenza. Quindi, dato che la resistenza non \xE8 nota all'inizio del progetto, anche la rigidezza non pu\xF2 essere nota. Questo significa che la stima del periodo di vibrazione della struttura non \xE8 accurata e, a cascata, non lo \xE8 nemmeno la domanda sismica. Questo significa che il Force-Based Design \xE8, in linea di principio, un processo iterativo. Inoltre \xE8 dimostrato che le regole dell'ugual spostamento o ugual energia non sono applicabili a tutte le tipologie di strutture (anche in termini di materiale costruttivo). ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      "Per superare queste inconsistenze (e altre), Priestley ha sviluppato il Direct Displacement-Based Design (DDBD, Priestley et al., 2007). Il metodo si focalizza sugli spostamenti anzich\xE8 sulle forze. Infatti, se si punta ad una progettazione a danno controllato, \xE8 dimostrato che gli spostamenti siano un indicatore del danno rispetto alle forze. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("img", { src: _6.default, style: { width: '100%', height: '100%' } }),
	      "Il DDBD inizia selezionando un livello di spostamento per cui si vuole progettare la struttura. Questo permette al progettista di avere un totale controllo del comportamento previsto della struttura, in relazione ai limiti dei materiali o limiti dettati dal codice normativo. La capacit\xE0 della struttura di dissipare energia \xE8 calcolata con relazioni calibrate in funzione di ogni tipologia costruttiva. Quindi, sulla base della domanda sismica si stima il periodo efficace della struttura relativo allo spostamento target. Questo corrisponde ad un valore della rigidezza secante per cui la struttura deve essere progettata, e quindi ad un taglio alla base. Infine si progettano gli elementi strutturali per garantire una resistenza coerente con la domanda sismica e allo stesso tempo un meccanismo plastico sufficientemente duttile. La gerarchia delle resistenze \xE8 infine applicata per evitare l'insorgere di qualsiasi meccanismo fragile. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(_reactResponsiveEmbed2.default, { src: "https://www.youtube.com/embed/MZUhSHmIUdI", allowFullScreen: true })
	    )
	  );
	};
	
	exports.default = Index;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ddbd-it-jsx-6f5a671fcf203894c38d.js